import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const usePhotosGalleryStore = defineStore('photosGallery', {
  state,
  getters,
  actions
})


export default usePhotosGalleryStore
